import React from 'react'

import { StyledHeader } from './styles'

export interface IHeader {
  color?: 'error' | 'default'
}
const Header: React.FC<IHeader> = ({ children, color }) => {
  return <StyledHeader color={color}>{children}</StyledHeader>
}

export default Header
